import BarekamText from "../../pages/components/text";
import {Grid} from "@mui/material";
import {SidebarPageContainer, SidebarPageContentContainer, SidebarPageTitleContainer} from "./styled";
import Message from "../../pages/components/message";
import {MessageSections} from "../../pages/components/message/message";
import React, {useEffect, useState} from "react";
import {useAppSelector} from "../../redux/store";
import {AdditionalServiceWarehouseCard} from "./card/additional-service-warehouse-card";
import ordersService from "../../services/orders.service";

const AdditionalServicesPage = () => {
    const {additionalServices} = useAppSelector(state => state.staticDataReducer);
    const [onHoldOrdersCount, setOnHoldOrdersCount] = useState<number>(0);

    useEffect(() => {
        ordersService.getOrdersCount({additionalService: 6})
            .then(payload => {
                if (payload) {
                    const count = payload.totalItems;
                    setOnHoldOrdersCount(count);
                }
            })
    }, []);

    return (
        <SidebarPageContainer>
            <SidebarPageTitleContainer>
                <BarekamText variant={"xxl"} bold>
                    <Message messageKey={'additional_services_page_title'} sectionId={MessageSections.CALCULATE}/>
                </BarekamText>
            </SidebarPageTitleContainer>

            <SidebarPageContentContainer container spacing={2} rowSpacing={4}>
                {additionalServices
                    .filter(service => service.name === 'on_hold')
                    .map(service => {
                    return (
                        <Grid item xs={6}>
                            <AdditionalServiceWarehouseCard service={service} onClick={() => void(0)} ordersCount={onHoldOrdersCount}/>
                        </Grid>
                    )
                })}
            </SidebarPageContentContainer>

        </SidebarPageContainer>
    );
};

export default AdditionalServicesPage;
